import { TFunction } from "i18next";
import { AdManagerFilterTab, AdManagerSortOrder, AdPostModelNextButtonKind, BuyOrSellKind, PFSzalagKiemelesVariant, PlanFeatureKind, PlanOrderKind, PriceDTO, PriceFlag, PriceQuantity, PurchasePaymode, PurchasePeriod, UjVagyHasznaltKind } from "../../client/swaggerClient";

// Általános, több helyen használt title-k
export const purchasePaymodeTitle = {
  [PurchasePaymode.NincsMegadva]: 'common.purchasePaymode.nincsMegadva',
  [PurchasePaymode.Transfer]: 'common.purchasePaymode.transfer',
  [PurchasePaymode.SMS]: 'common.purchasePaymode.sms',
  [PurchasePaymode.Card]: 'common.purchasePaymode.card',
  [PurchasePaymode.Paypal]: 'common.purchasePaymode.paypal',
  [PurchasePaymode.Csekk]: 'common.purchasePaymode.csekk',
  [PurchasePaymode.Other]: 'common.purchasePaymode.other'
}

export const purchasePeriodTitle = {
  [PurchasePeriod.NincsMegadva]: 'common.purchasePeriod.nincsMegadva',
  [PurchasePeriod.Monthly]: 'common.purchasePeriod.monthly',
  [PurchasePeriod.Yearly]: 'common.purchasePeriod.yearly'
}

export const priceQuantityTitle =  {
  [PriceQuantity.Alkalom]: 'common.priceQuantity.alkalom',
  [PriceQuantity.Darab]: 'common.priceQuantity.darab',
  [PriceQuantity.Ev]: 'common.priceQuantity.ev',
  [PriceQuantity.Garnitura]: 'common.priceQuantity.garnitura',
  [PriceQuantity.Ho]: 'common.priceQuantity.ho',
  [PriceQuantity.Nap]: 'common.priceQuantity.nap',
  [PriceQuantity.Oldal]: 'common.priceQuantity.oldal',
  [PriceQuantity.Par]: 'common.priceQuantity.par'
}

export const priceFlagTitle = {
  [PriceFlag.FixAr]: 'common.priceFlag.fixAr',
  [PriceFlag.Iranyar]: 'common.priceFlag.iranyar',
  [PriceFlag.PluszAfa]: 'common.priceFlag.pluszAfa'
}

export const ujVagyHasznaltKindText = {
  [UjVagyHasznaltKind.Uj]: 'common.ujVagyHasznaltKind.uj',
  [UjVagyHasznaltKind.Hasznalt]: 'common.ujVagyHasznaltKind.hasznalt',
  [UjVagyHasznaltKind.Felujitott]: 'common.ujVagyHasznaltKind.felujitott'
}

export const buyOrSellKindText = {
  [BuyOrSellKind.BerbeAd]: 'common.buyOrSellKind.berdbeAd',
  [BuyOrSellKind.Berelne]: 'common.buyOrSellKind.berelne',
  [BuyOrSellKind.Elado]: 'common.buyOrSellKind.elado',
  [BuyOrSellKind.Keres]: 'common.buyOrSellKind.keres'
}

export const pfSzalagKiemelesVariantTitle = {
  [PFSzalagKiemelesVariant.AkciosAr]: 'common.pfSzalagKiemelesVariant.akciosAr',
  [PFSzalagKiemelesVariant.Alkukepes]: 'common.pfSzalagKiemelesVariant.alkukepes',
  [PFSzalagKiemelesVariant.IngyenesSzallitas]: 'common.pfSzalagKiemelesVariant.ingyenesSzallitas',
  [PFSzalagKiemelesVariant.UtolsoDarab]: 'common.pfSzalagKiemelesVariant.utolsoDarab'
}

// Konkrét komponensekben használt title-k
export const adPostModelNextButtonTitle = {
  [AdPostModelNextButtonKind.NextButton]: 'web.adPost.adPostModelNextButtonKind.nextButton',
  [AdPostModelNextButtonKind.FinishButton]: 'web.adPost.adPostModelNextButtonKind.finishButton',
  [AdPostModelNextButtonKind.FinishOrHighlightButton]: 'web.adPost.adPostModelNextButtonKind.finishOrHighlightButton',
  [AdPostModelNextButtonKind.EditingSave]: 'web.adPost.adPostModelNextButtonKind.editSave'
}

export const planOrderKindTitle = {
	[PlanOrderKind.NewOrder]: 'web.plan.planOrderKind.newOrder',
	[PlanOrderKind.Upgrade]: 'web.plan.planOrderKind.upgrade',
	[PlanOrderKind.Downgrade]: 'web.plan.planOrderKind.downgrade',
	[PlanOrderKind.Cancel]: 'web.plan.planOrderKind.cancel',
}

export const adManagerFilterTabTitle = {
  [AdManagerFilterTab.NotDeleted]: 'web.dashboard.adManager.adNotDeleteTab',
  [AdManagerFilterTab.UserDeleted]: 'web.dashboard.adManager.adUserDeletedTab',
  [AdManagerFilterTab.Expired]: 'web.dashboard.adManager.adExpiredTab',
  [AdManagerFilterTab.Massimported]: 'web.dashboard.adManager.adMassimportedTab'
}

export const adManagerSortOrderTitle = {
  [AdManagerSortOrder.DisplayedAt]: 'web.dashboard.adManager.adRendezes.displayedAt',
  [AdManagerSortOrder.DeletedAt]: 'web.dashboard.adManager.adRendezes.deletedAt',
  [AdManagerSortOrder.ExpireAsc]: 'web.dashboard.adManager.adRendezes.expireAsc', 
  [AdManagerSortOrder.ExpireDesc]: 'web.dashboard.adManager.adRendezes.expireDesc', 
  [AdManagerSortOrder.PriceAsc]: 'web.dashboard.adManager.adRendezes.priceAsc',
  [AdManagerSortOrder.PriceDesc]: 'web.dashboard.adManager.adRendezes.priceDesc',
  [AdManagerSortOrder.VisitCountDesc]: 'web.dashboard.adManager.adRendezes.visitCountDesc'
}

export const planFeatureKindTitle = {
  [PlanFeatureKind.PFAktivHirdetesLimit] : 'web.adKiemeles.planFutureKind.pfAktivHirdetesLimit',
  [PlanFeatureKind.PFAutoElorehozas]: 'web.adKiemeles.planFutureKind.pfAutoElorehozas',
  [PlanFeatureKind.PFKezdooldalKiemeles]: 'web.adKiemeles.planFutureKind.pfKezdooldalKiemeles',
  [PlanFeatureKind.PFListaFolottiKiemeles]: 'web.adKiemeles.planFutureKind.pfListaFolottiKiemeles',
  [PlanFeatureKind.PFMassimport]: 'web.adKiemeles.planFutureKind.pfMassimport',
  [PlanFeatureKind.PFSzalagKiemeles]: 'web.adKiemeles.planFutureKind.pfSzalagKiemeles',
  [PlanFeatureKind.AdPostLimit]: 'web.adKiemeles.planFutureKind.pfAdPostLimit'
}

export const planFeatureOldKindTitle = {
  [PlanFeatureKind.AdPostLimit]: 'web.adKiemeles.planFutureKind.pfAdPostLimit'
}


export const nodeEnvText = {
  "production": "PROD",
  "development": "DEV"
}

export const getPriceFlagString = (t: TFunction<"translation", unknown>, price: PriceDTO | undefined) => {
  let priceFlagString = ''
  
  if (price?.flags?.includes(PriceFlag.Iranyar)) priceFlagString += `(${t(priceFlagTitle[PriceFlag.Iranyar])}) `
  if (price?.flags?.includes(PriceFlag.FixAr)) priceFlagString += `(${t(priceFlagTitle[PriceFlag.FixAr])}) `
  if (price?.flags?.includes(PriceFlag.PluszAfa)) priceFlagString += `(${t(priceFlagTitle[PriceFlag.PluszAfa])})`

  return priceFlagString
}